var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d68828;stroke:#d68828;}.cls-1,.cls-2{stroke-width:0.5px;}.cls-2{fill:#fff;stroke:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2211",
    "data-name": "Group 2211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    className: "cls-1",
    d: "M29.33,45.29a1.14,1.14,0,0,1-1.14-1.14,1.19,1.19,0,0,1,.19-.63L41.27,24.19a1.14,1.14,0,1,1,1.89,1.26h0L30.27,44.78A1.12,1.12,0,0,1,29.33,45.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    className: "cls-1",
    cx: 30.12,
    cy: 27.23,
    r: 2.42
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    className: "cls-1",
    cx: 41.4,
    cy: 41.73,
    r: 2.42
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    className: "cls-2",
    d: "M60.13,51.73H11.39a2.51,2.51,0,0,1-2.55-2.48V45.68A6.58,6.58,0,0,1,11.7,41a8.31,8.31,0,0,0,3.58-6.56,7.46,7.46,0,0,0-3.49-6,6.25,6.25,0,0,1-2.95-4.57V19.71a2.51,2.51,0,0,1,2.55-2.48H60.13a2.51,2.51,0,0,1,2.55,2.48v4.23a6.26,6.26,0,0,1-3,4.57,7.48,7.48,0,0,0-3.49,6A8.34,8.34,0,0,0,59.81,41a6.56,6.56,0,0,1,2.87,4.64v3.57A2.51,2.51,0,0,1,60.13,51.73ZM11.39,19.51a.26.26,0,0,0-.28.2V24c0,.95.82,1.69,2.16,2.83a9.67,9.67,0,0,1,4.29,7.7,10.56,10.56,0,0,1-4.32,8.24c-1.32,1.21-2.13,2-2.13,3v3.57a.27.27,0,0,0,.28.21H60.13a.25.25,0,0,0,.27-.21V45.68c0-1-.81-1.75-2.12-3A10.56,10.56,0,0,1,54,34.48a9.67,9.67,0,0,1,4.29-7.7c1.33-1.13,2.15-1.89,2.15-2.83V19.71a.24.24,0,0,0-.27-.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherIcon);
export default __webpack_public_path__ + "static/media/voucher-icon.195d7ebd3fa0319db812716ab09fd16a.svg";
export { ForwardRef as ReactComponent };